import { useState } from 'react'
import { Unlock } from 'lucide-react'
import { addAuditEntry } from '../../lib/store'

export default function DepartmentsTab({ departments, onActivate, addToast }) {
  const [showChecklist, setShowChecklist] = useState(false)

  const handleActivate = (name) => {
    onActivate(name)
    addAuditEntry(name, 'ACTIVATE_DEPARTMENT', 'departments', null, { isActive: false }, { isActive: true })
    addToast(`${name} department activated`, 'success')
  }

  return (
    <div className="space-y-4">
      {departments.map(dept => (
        <div key={dept.name} className="bg-gray-800/50 border border-gray-700 rounded-lg p-4">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="font-medium">{dept.displayName}</h3>
              <span className={`text-xs px-2 py-0.5 rounded-full ${
                dept.isActive ? 'bg-green-900 text-green-400' : 'bg-gray-700 text-gray-400'
              }`}>
                {dept.isActive ? 'Active' : 'Inactive'}
              </span>
            </div>
            {!dept.isActive && (
              <button
                onClick={() => setShowChecklist(true)}
                className="flex items-center gap-1 bg-brand-600 hover:bg-brand-500 text-white px-3 py-2 rounded text-sm"
              >
                <Unlock size={14} /> Activate
              </button>
            )}
          </div>
        </div>
      ))}

      {showChecklist && (
        <div className="bg-gray-900 border border-amber-800 rounded-lg p-6">
          <h3 className="font-medium mb-4 text-amber-400">Bakery Activation Checklist</h3>
          <div className="space-y-3 mb-6">
            {[
              'Define bakery item categories',
              'Set sale type per product (discrete / continuous / fixed_unit)',
              'Set QPS per product',
              'Define waste thresholds per category',
              'Configure flagging rules',
              'Upload historical bakery data (optional)',
            ].map((item, i) => (
              <label key={i} className="flex items-center gap-2 text-sm text-gray-300">
                <input type="checkbox" className="rounded bg-gray-800 border-gray-700" />
                {item}
              </label>
            ))}
          </div>
          <div className="flex gap-3">
            <button
              onClick={() => { handleActivate('bakery'); setShowChecklist(false) }}
              className="bg-green-700 hover:bg-green-600 text-white px-4 py-2 rounded text-sm"
            >
              Confirm Activation
            </button>
            <button
              onClick={() => setShowChecklist(false)}
              className="bg-gray-700 text-gray-300 px-4 py-2 rounded text-sm"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
